module.exports = __webpack_public_path__ + "static/media/programming.15cc7aea.svg";